// Central module configuration — drives navigation, forms, tables & global search.
export const MODULES = {
  projects: {
    key: "projects",
    name: "Projects",
    singular: "Project",
    icon: "FolderKanban",
    accent: "#4F46E5",
    titleField: "name",
    subtitleField: "client_name",
    columns: ["name", "client_name", "project_code", "status"],
    filters: { status: ["Planning", "Active", "On Hold", "Completed", "Closed"] },
    fields: [
      { name: "name", label: "Project Name", type: "text", required: true },
      { name: "client_name", label: "Client / Company", type: "text" },
      { name: "project_code", label: "Project Code", type: "text" },
      { name: "site_address", label: "Site Address", type: "textarea" },
      { name: "status", label: "Status", type: "select", options: ["Planning", "Active", "On Hold", "Completed", "Closed"], default: "Active" },
      { name: "project_manager", label: "Project Manager", type: "text" },
      { name: "start_date", label: "Start Date", type: "date" },
      { name: "expected_completion_date", label: "Expected Completion", type: "date" },
      { name: "actual_completion_date", label: "Actual Completion", type: "date" },
      { name: "contract_value", label: "Contract Value", type: "number" },
      { name: "scope_of_work", label: "Scope of Work", type: "textarea" },
      { name: "notes", label: "Important Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "attachment", label: "Attachment", type: "file" },
    ],
  },
  contacts: {
    key: "contacts",
    name: "Contacts",
    singular: "Contact",
    icon: "Contact",
    accent: "#0EA5E9",
    titleField: "full_name",
    subtitleField: "company",
    columns: ["full_name", "company", "designation", "mobile", "category"],
    filters: {
      category: ["Client Management", "Site In-Charge", "Security", "Electrical Department", "Accounts Department", "Labour Contractor", "Transporter", "Crane Operator", "Hydra Operator", "Scrap Buyer", "Vendor", "Technician", "Emergency Contact", "Other"],
    },
    quickActions: true,
    fields: [
      { name: "full_name", label: "Full Name", type: "text", required: true },
      { name: "company", label: "Company", type: "text" },
      { name: "designation", label: "Designation", type: "text" },
      { name: "department", label: "Department", type: "text" },
      { name: "category", label: "Category", type: "select", options: ["Client Management", "Site In-Charge", "Security", "Electrical Department", "Accounts Department", "Labour Contractor", "Transporter", "Crane Operator", "Hydra Operator", "Scrap Buyer", "Vendor", "Technician", "Emergency Contact", "Other"], default: "Other" },
      { name: "mobile", label: "Mobile", type: "tel" },
      { name: "alt_mobile", label: "Alternate Mobile", type: "tel" },
      { name: "whatsapp", label: "WhatsApp", type: "tel" },
      { name: "email", label: "Email", type: "email" },
      { name: "address", label: "Address", type: "textarea" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "purpose", label: "Purpose", type: "text" },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "photo", label: "Profile Photo", type: "file" },
    ],
  },
  documents: {
    key: "documents",
    name: "Documents",
    singular: "Document",
    icon: "FileText",
    accent: "#8B5CF6",
    titleField: "title",
    subtitleField: "category",
    columns: ["title", "category", "doc_number", "expiry_date"],
    filters: {
      category: ["Purchase Orders", "Proforma Invoices", "Quotations", "Tax Invoice", "Contracts / Agreements", "Work Orders", "Authorization Letters", "Permissions", "Insurance", "Licences", "Company Documents", "Client Letters", "Important Emails", "Certificates", "Payment Proof", "Receipt", "Challan", "Vehicle Documents", "Labour Documents", "Vendor Documents", "Machine Documents", "Other"],
    },
    fields: [
      { name: "title", label: "Document Title", type: "text", required: true },
      { name: "category", label: "Category", type: "select", options: ["Purchase Orders", "Proforma Invoices", "Quotations", "Tax Invoice", "Contracts / Agreements", "Work Orders", "Authorization Letters", "Permissions", "Insurance", "Licences", "Company Documents", "Client Letters", "Important Emails", "Certificates", "Payment Proof", "Receipt", "Challan", "Vehicle Documents", "Labour Documents", "Vendor Documents", "Machine Documents", "Other"], default: "Other" },
      { name: "doc_number", label: "Document Number", type: "text" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "related_company", label: "Related Company", type: "text" },
      { name: "issue_date", label: "Issue Date", type: "date" },
      { name: "expiry_date", label: "Expiry Date", type: "date" },
      { name: "file", label: "Upload File", type: "file" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "notes", label: "Notes", type: "textarea" },
    ],
  },
  vendors: {
    key: "vendors",
    name: "Vendors",
    singular: "Vendor",
    icon: "Truck",
    accent: "#F59E0B",
    titleField: "vendor_name",
    subtitleField: "category",
    columns: ["vendor_name", "contact_person", "mobile", "category", "current_rate"],
    filters: {
      category: ["Oxygen", "LPG", "Diesel", "Tools", "Safety Equipment", "Electrical Material", "Crane", "Hydra", "Forklift", "Transport", "Food", "Water", "Repair", "Machine Spare", "General Supplier", "Other"],
    },
    quickActions: true,
    fields: [
      { name: "vendor_name", label: "Vendor Name", type: "text", required: true },
      { name: "contact_person", label: "Contact Person", type: "text" },
      { name: "mobile", label: "Mobile", type: "tel" },
      { name: "whatsapp", label: "WhatsApp", type: "tel" },
      { name: "email", label: "Email", type: "email" },
      { name: "category", label: "Category", type: "select", options: ["Oxygen", "LPG", "Diesel", "Tools", "Safety Equipment", "Electrical Material", "Crane", "Hydra", "Forklift", "Transport", "Food", "Water", "Repair", "Machine Spare", "General Supplier", "Other"], default: "Other" },
      { name: "products", label: "Products / Services", type: "textarea" },
      { name: "current_rate", label: "Current Rate", type: "text" },
      { name: "credit_period", label: "Credit Period", type: "text" },
      { name: "gst", label: "GST Number", type: "text" },
      { name: "pan", label: "PAN", type: "text" },
      { name: "bank_details", label: "Bank Details", type: "textarea" },
      { name: "address", label: "Address", type: "textarea" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "rating", label: "Rating", type: "select", options: ["1", "2", "3", "4", "5"] },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "document", label: "Document", type: "file" },
    ],
  },
  followups: {
    key: "followups",
    name: "Follow-Ups",
    singular: "Follow-Up",
    icon: "ListTodo",
    accent: "#EF4444",
    titleField: "title",
    subtitleField: "status",
    columns: ["title", "assigned_to", "priority", "due_date", "status"],
    filters: {
      status: ["Pending", "In Progress", "Waiting", "Completed", "Cancelled"],
      priority: ["Low", "Medium", "High", "Urgent"],
    },
    fields: [
      { name: "title", label: "Task Title", type: "text", required: true },
      { name: "description", label: "Description", type: "textarea" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "related_to", label: "Related Person / Company", type: "text" },
      { name: "assigned_to", label: "Assigned To", type: "text" },
      { name: "priority", label: "Priority", type: "select", options: ["Low", "Medium", "High", "Urgent"], default: "Medium" },
      { name: "status", label: "Status", type: "select", options: ["Pending", "In Progress", "Waiting", "Completed", "Cancelled"], default: "Pending" },
      { name: "due_date", label: "Due Date", type: "date" },
      { name: "reminder_date", label: "Reminder Date", type: "date" },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
    ],
  },
  staff: {
    key: "staff",
    name: "Staff & Labour",
    singular: "Staff",
    icon: "HardHat",
    accent: "#14B8A6",
    titleField: "name",
    subtitleField: "role",
    columns: ["name", "role", "mobile", "contractor", "monthly_rate", "status"],
    summaryType: "staff",
    filters: { status: ["Active", "Inactive", "Left", "Suspended"] },
    quickActions: true,
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "worker_id", label: "Employee / Worker ID", type: "text" },
      { name: "role", label: "Role", type: "text" },
      { name: "mobile", label: "Mobile", type: "tel" },
      { name: "alt_mobile", label: "Alternate Number", type: "tel" },
      { name: "contractor", label: "Contractor / Company", type: "text" },
      { name: "status", label: "Status", type: "select", options: ["Active", "Inactive", "Left", "Suspended"], default: "Active" },
      { name: "joining_date", label: "Joining Date", type: "date" },
      { name: "leaving_date", label: "Leaving Date", type: "date" },
      { name: "monthly_rate", label: "Monthly Payment", type: "number" },
      { name: "id_type", label: "ID Type", type: "select", options: ["Aadhaar", "PAN", "Voter ID", "Driving Licence", "Passport", "Other"] },
      { name: "id_ref", label: "ID Reference Number", type: "text" },
      { name: "address", label: "Address", type: "textarea" },
      { name: "emergency_contact_name", label: "Emergency Contact Name", type: "text" },
      { name: "emergency_contact_number", label: "Emergency Contact Number", type: "tel" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "photo", label: "Photo", type: "file" },
      { name: "attachment", label: "Attachment", type: "file" },
    ],
  },
  materials: {
    key: "materials",
    name: "Sold Material / Scrap",
    singular: "Sold Material",
    icon: "Recycle",
    accent: "#22C55E",
    titleField: "material_name",
    subtitleField: "category",
    summaryType: "materials",
    dateFilter: "sale_date",
    filterLabels: { issuer: "Company" },
    columns: ["sale_date", "material_name", "issuer", "tax_invoice_number", "actual_weight", "rate", "estimated_value", "buyer", "status"],
    filters: {
      issuer: ["BSPMT", "BSPE"],
      status: ["In Stock", "Reserved", "Sold", "Dispatched"],
      category: ["MS Scrap", "CI Scrap", "Stainless Steel", "Copper", "Aluminium", "Machinery", "Structural Steel", "Plate", "Cable", "Motor", "Reusable Material", "Other"],
    },
    fields: [
      { name: "material_name", label: "Material Name", type: "text", required: true },
      { name: "sale_date", label: "Sale Date", type: "date", defaultToday: true },
      { name: "issuer", label: "Company", type: "select", options: ["BSPMT", "BSPE"], optionLabels: { BSPMT: "BSP Machines & Tools Pvt. Ltd. (BSPMT)", BSPE: "BSP Enterprise (BSPE)" }, default: "BSPMT" },
      { name: "tax_invoice_number", label: "Tax Invoice Number", type: "text" },
      { name: "category", label: "Category", type: "select", options: ["MS Scrap", "CI Scrap", "Stainless Steel", "Copper", "Aluminium", "Machinery", "Structural Steel", "Plate", "Cable", "Motor", "Reusable Material", "Other"], default: "Other" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "site_location", label: "Site Location", type: "text" },
      { name: "quantity", label: "Approx. Quantity", type: "text" },
      { name: "quantity_unit", label: "Quantity Unit", type: "text" },
      { name: "actual_weight", label: "Actual Weight", type: "text" },
      { name: "weight_unit", label: "Weight Unit", type: "select", options: ["MT", "Kg", "Ton", "Nos"], default: "MT" },
      { name: "buyer", label: "Buyer", type: "text" },
      { name: "rate", label: "Sold Rate", type: "number", hint: "When the status is Sold or Dispatched, this updates the last sold rate for this material type in Rates." },
      { name: "estimated_value", label: "Value", type: "number" },
      { name: "status", label: "Status", type: "select", options: ["In Stock", "Reserved", "Sold", "Dispatched"], default: "In Stock" },
      { name: "dispatch_date", label: "Dispatch Date", type: "date" },
      { name: "vehicle_number", label: "Vehicle Number", type: "text" },
      { name: "weighbridge", label: "Weighbridge Info", type: "text" },
      { name: "challan", label: "Challan / Reference", type: "text" },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "photo", label: "Photograph", type: "file" },
      { name: "document", label: "Document", type: "file" },
    ],
  },
  notes: {
    key: "notes",
    name: "Daily Notes",
    singular: "Note",
    icon: "NotebookPen",
    accent: "#F97316",
    titleField: "title",
    subtitleField: "work_completed",
    columns: ["title", "note_date", "person_contacted", "follow_up_required"],
    filters: { follow_up_required: ["Yes", "No"] },
    fields: [
      { name: "note_date", label: "Date", type: "date" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "title", label: "Note Title", type: "text", required: true },
      { name: "work_completed", label: "Work Completed", type: "textarea" },
      { name: "problem_faced", label: "Problem Faced", type: "textarea" },
      { name: "person_contacted", label: "Person Contacted", type: "text" },
      { name: "decision_taken", label: "Decision Taken", type: "textarea" },
      { name: "follow_up_required", label: "Follow-up Required", type: "select", options: ["Yes", "No"], default: "No" },
      { name: "follow_up_date", label: "Follow-up Date", type: "date" },
      { name: "notes", label: "Additional Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "photo", label: "Photo", type: "file" },
      { name: "attachment", label: "Attachment", type: "file" },
    ],
  },
  rates: {
    key: "rates",
    name: "Rates",
    singular: "Rate",
    icon: "IndianRupee",
    accent: "#EAB308",
    titleField: "rate_title",
    subtitleField: "category",
    columns: ["rate_title", "amount", "unit", "vendor_person", "updated_at", "notes"],
    filters: {
      rate_type: ["Purchase", "Selling", "General"],
      category: ["Labour/day", "Skilled labour/day", "Helper/day", "Gas cutting", "Oxygen cylinder", "LPG cylinder", "Diesel/litre", "Petrol/litre", "Crane/hour", "Hydra/hour", "Forklift/hour", "Transportation/km", "Transportation/trip", "MS scrap/MT", "CI scrap/MT", "Copper/kg", "Aluminium/kg", "Stainless steel/kg", "Consumables", "Tools", "Other"],
    },
    fields: [
      { name: "rate_title", label: "Rate Title", type: "text", required: true },
      { name: "rate_type", label: "Rate Book", type: "select", options: ["Purchase", "Selling", "General"], default: "Purchase" },
      { name: "category", label: "Category", type: "select", options: ["Labour/day", "Skilled labour/day", "Helper/day", "Gas cutting", "Oxygen cylinder", "LPG cylinder", "Diesel/litre", "Petrol/litre", "Crane/hour", "Hydra/hour", "Forklift/hour", "Transportation/km", "Transportation/trip", "MS scrap/MT", "CI scrap/MT", "Copper/kg", "Aluminium/kg", "Stainless steel/kg", "Consumables", "Tools", "Other"], default: "Other" },
      { name: "vendor_person", label: "Vendor / Person", type: "text" },
      { name: "amount", label: "Amount", type: "number" },
      { name: "unit", label: "Unit", type: "text" },
      { name: "effective_date", label: "Effective Date", type: "date" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "previous_rate", label: "Previous Rate", type: "readonly" },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "rate_history", label: "Rate History", type: "history" },
    ],
  },
  private_notes: {
    key: "private_notes",
    name: "Private Notes",
    singular: "Private Note",
    icon: "Lock",
    accent: "#DC2626",
    private: true,
    titleField: "title",
    subtitleField: "related_to",
    columns: ["title", "related_to", "reminder"],
    filters: {},
    fields: [
      { name: "note_date", label: "Date", type: "date" },
      { name: "title", label: "Title", type: "text", required: true },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "related_to", label: "Related Person / Company", type: "text" },
      { name: "negotiation_notes", label: "Negotiation Notes", type: "textarea" },
      { name: "rate_discussion", label: "Rate Discussion", type: "textarea" },
      { name: "commitment", label: "Commitment", type: "textarea" },
      { name: "reminder", label: "Reminder Date", type: "date" },
      { name: "remarks", label: "Internal Remarks", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "attachment", label: "Attachment", type: "file" },
    ],
  },
  decisions: {
    key: "decisions",
    name: "Decisions",
    singular: "Decision",
    icon: "Gavel",
    accent: "#6366F1",
    titleField: "decision_title",
    subtitleField: "approved_by",
    columns: ["decision_title", "approved_by", "decision_date", "status"],
    filters: { status: ["Open", "Pending", "Implemented", "Cancelled"] },
    fields: [
      { name: "decision_date", label: "Date", type: "date" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "decision_title", label: "Decision Title", type: "text", required: true },
      { name: "decision_details", label: "Decision Details", type: "textarea" },
      { name: "reason", label: "Reason", type: "textarea" },
      { name: "approved_by", label: "Approved By", type: "text" },
      { name: "related_company", label: "Related Company", type: "text" },
      { name: "related_person", label: "Related Person", type: "text" },
      { name: "status", label: "Status", type: "select", options: ["Open", "Pending", "Implemented", "Cancelled"], default: "Open" },
      { name: "follow_up_required", label: "Follow-up Required", type: "select", options: ["Yes", "No"], default: "No" },
      { name: "follow_up_date", label: "Follow-up Date", type: "date" },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "supporting_document", label: "Supporting Document", type: "file" },
    ],
  },
  emergency: {
    key: "emergency",
    name: "Emergency",
    singular: "Emergency Contact",
    icon: "Siren",
    accent: "#DC2626",
    customPath: "/emergency",
    titleField: "name",
    subtitleField: "organization",
    columns: ["name", "organization", "category", "phone"],
    filters: {
      category: ["Hospital", "Ambulance", "Police", "Fire Brigade", "Site Security", "Client Emergency Contact", "Electrical Emergency", "Machine Technician", "Insurance Contact", "Management", "Other"],
    },
    quickActions: true,
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "organization", label: "Organization", type: "text" },
      { name: "category", label: "Category", type: "select", options: ["Hospital", "Ambulance", "Police", "Fire Brigade", "Site Security", "Client Emergency Contact", "Electrical Emergency", "Machine Technician", "Insurance Contact", "Management", "Other"], default: "Other" },
      { name: "phone", label: "Phone", type: "tel" },
      { name: "alt_phone", label: "Alternate Number", type: "tel" },
      { name: "address", label: "Address", type: "textarea" },
      { name: "map_link", label: "Location / Map Link", type: "text" },
      { name: "available_hours", label: "Available Hours", type: "text" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "notes", label: "Notes", type: "textarea" },
    ],
  },
  expenses: {
    key: "expenses",
    name: "Expenses",
    singular: "Expense",
    icon: "Receipt",
    accent: "#DB2777",
    titleField: "description",
    subtitleField: "category",
    summary: { field: "amount", label: "Total Expenses", prefix: "₹" },
    columns: ["description", "category", "amount", "vendor_person", "expense_date"],
    filters: {
      category: ["Labour", "Fuel", "Oxygen", "LPG", "Transport", "Equipment Rental", "Food", "Water", "Security", "Repairs", "Electrical", "Tools", "Consumables", "Miscellaneous"],
    },
    fields: [
      { name: "expense_date", label: "Date", type: "date" },
      { name: "category", label: "Category", type: "select", options: ["Labour", "Fuel", "Oxygen", "LPG", "Transport", "Equipment Rental", "Food", "Water", "Security", "Repairs", "Electrical", "Tools", "Consumables", "Miscellaneous"], default: "Miscellaneous" },
      { name: "description", label: "Description", type: "text", required: true },
      { name: "amount", label: "Amount", type: "number" },
      { name: "vendor_person", label: "Vendor / Person", type: "text" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "reference", label: "Reference / Document No.", type: "text" },
      { name: "payment_mode", label: "Payment Mode", type: "select", options: ["Cash", "Bank Transfer", "UPI", "Cheque", "Card", "Credit", "Other"], default: "Cash" },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "document", label: "Document", type: "file" },
    ],
  },
  buyers: {
    key: "buyers",
    name: "Buyers",
    singular: "Buyer",
    icon: "ShoppingCart",
    accent: "#0D9488",
    titleField: "buyer_name",
    subtitleField: "products",
    quickActions: true,
    columns: ["buyer_name", "contact_person", "mobile", "products"],
    filters: {},
    fields: [
      { name: "buyer_name", label: "Buyer Name", type: "text", required: true },
      { name: "contact_person", label: "Contact Person", type: "text" },
      { name: "mobile", label: "Mobile", type: "tel" },
      { name: "whatsapp", label: "WhatsApp", type: "tel" },
      { name: "email", label: "Email", type: "email" },
      { name: "products", label: "Materials Bought", type: "textarea" },
      { name: "gst", label: "GST Number", type: "text" },
      { name: "pan", label: "PAN", type: "text" },
      { name: "bank_details", label: "Bank Details", type: "textarea" },
      { name: "address", label: "Address", type: "textarea" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "rating", label: "Rating", type: "select", options: ["1", "2", "3", "4", "5"] },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "document", label: "Document", type: "file" },
    ],
  },
  payment_ledger: {
    key: "payment_ledger",
    name: "Payment Ledger",
    singular: "Payment",
    icon: "BookOpenCheck",
    accent: "#7C3AED",
    customPath: "/ledger",
    titleField: "party_name",
    subtitleField: "description",
    columns: ["date", "party_name", "payment_type", "reference", "payment_mode", "amount", "payment_status"],
    filters: {
      payment_type: ["IN", "OUT"],
    },
    fields: [
      { name: "date", label: "Date", type: "date", lockedIf: "money_receipt_id" },
      { name: "party_name", label: "Customer / Party Name", type: "party", required: true, lockedIf: "money_receipt_id" },
      { name: "party_type", label: "Party Type", type: "select", options: ["Customer", "Buyer", "Vendor", "Contractor", "Other"], default: "Customer" },
      { name: "payment_type", label: "Payment Type", type: "select", options: ["IN", "OUT"], default: "IN", lockedIf: "money_receipt_id" },
      { name: "issuer", label: "Company", type: "select", options: ["BSPMT", "BSPE"], optionLabels: { BSPMT: "BSP Machines & Tools Pvt. Ltd. (BSPMT)", BSPE: "BSP Enterprise (BSPE)" }, default: "BSPMT", lockedIf: "money_receipt_id", hint: "For Payment IN, a Money Receipt is generated automatically for this company when you save." },
      { name: "amount", label: "Amount", type: "number", lockedIf: "money_receipt_id" },
      { name: "payment_mode", label: "Payment Mode", type: "select", options: ["Cash", "NEFT", "RTGS", "IMPS", "UPI", "Cheque", "Bank Transfer", "Other"], default: "Cash", lockedIf: "money_receipt_id" },
      { name: "reference", label: "Transaction / Reference No.", type: "text", lockedIf: "money_receipt_id" },
      { name: "description", label: "Description / Narration", type: "textarea", lockedIf: "money_receipt_id" },
      { name: "project_id", label: "Related Project", type: "project" },
      { name: "payment_status", label: "Payment Status", type: "select", options: ["Pending", "Partially Paid", "Paid", "Overdue", "Cancelled"], default: "Paid" },
      { name: "invoice_value", label: "Invoice Value", type: "number" },
      { name: "amount_paid", label: "Amount Paid", type: "number" },
      { name: "outstanding", label: "Outstanding (auto)", type: "readonly" },
      { name: "po_number", label: "PO Number", type: "text" },
      { name: "proforma_number", label: "Proforma Invoice No.", type: "text" },
      { name: "invoice_number", label: "Tax Invoice No.", type: "text" },
      { name: "contract_reference", label: "Contract Reference", type: "text" },
      { name: "purchase_order", label: "Purchase Order (file)", type: "file" },
      { name: "proforma_invoice", label: "Proforma Invoice (file)", type: "file" },
      { name: "tax_invoice", label: "Tax Invoice (file)", type: "file" },
      { name: "quotation", label: "Quotation (file)", type: "file" },
      { name: "contract", label: "Contract / Agreement (file)", type: "file" },
      { name: "payment_proof", label: "Payment Proof (file)", type: "file" },
      { name: "receipt", label: "Receipt (file)", type: "file" },
      { name: "challan", label: "Challan (file)", type: "file" },
      { name: "other_document", label: "Other Document (file)", type: "file" },
      { name: "notes", label: "Notes", type: "textarea" },
      { name: "tags", label: "Tags", type: "tags" },
    ],
  },
};

export const MODULE_LIST = Object.values(MODULES);

export const STATUS_COLORS = {
  Active: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
  Planning: "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400",
  "On Hold": "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400",
  Completed: "bg-slate-100 text-slate-600 dark:bg-slate-500/15 dark:text-slate-300",
  Closed: "bg-slate-200 text-slate-700 dark:bg-slate-600/20 dark:text-slate-300",
  Pending: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400",
  "In Progress": "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400",
  Waiting: "bg-purple-100 text-purple-700 dark:bg-purple-500/15 dark:text-purple-400",
  Cancelled: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400",
  Inactive: "bg-slate-100 text-slate-600 dark:bg-slate-500/15 dark:text-slate-300",
  Left: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400",
  Suspended: "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-400",
  Open: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400",
  Implemented: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
  Purchase: "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400",
  Selling: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
  General: "bg-slate-100 text-slate-600 dark:bg-slate-500/15 dark:text-slate-300",
  Urgent: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400",
  High: "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-400",
  Medium: "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400",
  Low: "bg-slate-100 text-slate-600 dark:bg-slate-500/15 dark:text-slate-300",
  Overdue: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400",
  Paid: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
  "Partially Paid": "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400",
  "In Stock": "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400",
  Sold: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
  Dispatched: "bg-teal-100 text-teal-700 dark:bg-teal-500/15 dark:text-teal-400",
  Reserved: "bg-purple-100 text-purple-700 dark:bg-purple-500/15 dark:text-purple-400",
  IN: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
  OUT: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400",
};
